const blocImages = document.querySelectorAll('.gallery-container') || null;
if (blocImages) {
	setTimeout(() => {
		blocImages.forEach((bloc) => {
			const btns = bloc.querySelectorAll('.carousel__button');
			//@ts-ignore
			const txtPrev = js_trad.PrevItem;
			//@ts-ignore
			const txtNext = js_trad.NextItem;
			btns.forEach((btn) => {
				btn.classList.contains('is-prev')
					? btn.setAttribute('title', txtPrev)
					: btn.setAttribute('title', txtNext);
			});
		});
	}, 100);
}
